var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LikeColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "22.3693114%",
    x2: "99.999575%",
    y2: "27.7870935%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-18.6%",
    y: "-23.4%",
    width: "137.3%",
    height: "146.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.6096191,2.48608398 C90.3480225,-0.828674316 99.6519775,-0.828704834 105.390381,2.48605347 L171.196167,40.4981079 C174.285645,42.2827148 175.711792,44.6642761 175.474609,47 L175.5,47 L175.5,82 L175.474609,82 C175.27124,84.0027161 173.845093,85.9717407 171.196167,87.5018921 L105.390381,125.513947 C99.6519775,128.828705 90.3480225,128.828705 84.6096191,125.513947 L18.803833,87.5018921 C16.1549072,85.9717407 14.7287598,84.0027161 14.5253906,82 L14.5,82 L14.5,47 L14.5253906,47 C14.288208,44.6642761 15.7143555,42.2827148 18.803833,40.4981079 L84.6096191,2.48608398 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-6.6%",
    width: "110.6%",
    height: "113.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8133345%",
    x2: "93.8547498%",
    y2: "50.7911126%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95,0 C98.8971583,0 102.63469,0.89426525 105.390392,2.48606786 L171.196169,40.4980971 C173.95187,42.0898997 175.5,44.2488471 175.5,46.5 C175.5,48.7511453 173.95187,50.9100924 171.196169,52.5018953 L105.390384,90.5139228 C102.634682,92.1057257 98.8971507,93 95,93 C91.1028493,93 87.3653174,92.1057331 84.6096158,90.5139305 L18.8038396,52.5018991 C16.048138,50.9100965 14.5,48.7511491 14.5,46.5 C14.5,44.2488509 16.0481388,42.0899038 18.8038405,40.4981009 L84.6096158,2.48606857 C87.3653176,0.894265727 91.102857,0 95,0 Z M74.680679,22.1378088 C72.5588525,22.1387466 70.5243962,22.6260487 69.0240395,23.4927163 L42.3207506,38.917599 C40.8271621,39.7856319 39.9888355,40.9597735 39.9888354,42.1836318 C39.9888353,43.4074901 40.8271565,44.5816357 42.3207449,45.4496684 L52.0703917,51.0814515 C53.166327,51.7185722 54.5596497,52.1576225 56.0802978,52.3450234 C57.6009459,52.5324244 59.1831431,52.460071 60.633797,52.1367857 C61.9585711,54.3724932 64.3916586,57.8886024 67.586702,59.8742307 L68.0715864,60.1543181 C69.058673,60.63447 70.045759,61.2046529 71.1540668,61.8448555 C72.7212832,62.7501419 74.2452032,63.6804354 75.8557129,64.6807519 C77.4662226,65.6810684 79.1459998,66.7113932 80.8777307,67.7117097 C83.7984427,69.4538639 87.0220432,71.0176086 90.4974976,72.3781872 L91.4586162,72.7433006 L92.5842322,72.9033549 C94.3149583,73.1688245 96.140852,73.1437272 97.8477635,72.8310129 C99.5546749,72.5182987 101.071839,71.9309344 102.221322,71.1377968 C104.544752,71.617222 107.095798,71.572568 109.36471,71.0127573 C111.605366,70.4119653 113.44052,69.4011335 114.585883,68.1368473 C121.088532,68.5719848 124.205642,66.3712866 125.686272,64.3756551 C127.324784,64.3523405 128.931446,64.1091895 130.37926,63.6654274 C132.70832,62.9748425 134.467794,61.7786162 135.2714,60.3393743 C135.718186,59.5504913 135.884074,58.7175529 135.75908,57.8906739 C135.634086,57.0637948 135.220799,56.2600694 134.54408,55.5278543 L134.292981,55.2527695 L133.963948,55.0026866 C131.528787,53.2165375 128.872244,51.5349174 126.015298,49.9710957 C124.370153,49.020795 122.699039,48.0955018 121.062553,47.2002185 L119.027773,46.0248474 L119.633877,45.8147818 C125.219587,43.8490934 130.163828,41.3316905 134.241027,38.3774272 L134.561395,38.1923672 C134.743227,38.0473213 134.942382,37.8322534 135.245435,37.657198 C137.418757,36.001674 141.020752,33.2408007 139.219752,30.1998385 L138.691575,29.3245615 L136.959847,28.324245 C131.781972,25.3332986 126.985073,26.7037314 124.396136,27.9191162 C123.746736,28.1842001 123.097337,28.4492846 122.473914,28.6993637 C116.663957,31.0651125 112.828171,32.6206043 106.256252,32.9957232 C98.5240731,33.5308928 95.0692695,33.2057895 92.7747259,33.0307342 L92.402404,32.9957232 C92.5568502,32.2987372 92.4343893,31.590587 92.0443158,30.9250207 C91.6542423,30.2594543 91.0068104,29.6539634 90.1511566,29.1545077 L80.3409036,23.4877156 C78.8382529,22.6223753 76.8025054,22.136871 74.680679,22.1378088 Z M132.318805,31.1351339 L132.933568,31.4902477 C133.695529,32.7506466 130.335969,34.9013269 129.097782,35.9466577 C125.510374,38.533387 121.164034,40.7358931 116.256999,42.4537177 C115.399792,42.6087668 113.624768,43.6841078 112.923417,43.2789796 L112.73293,43.1689442 C110.083382,41.6384599 105.979177,43.9491913 108.680678,45.509685 L108.767263,45.5597 C109.719715,46.1698931 110.724118,46.7500744 111.737181,47.3352596 C114.914907,49.1708404 118.239834,50.9213951 121.408902,52.7519744 C123.972943,54.200399 126.35709,55.7514001 128.543632,57.3934462 C128.782017,57.624203 128.936609,57.8805659 128.998008,58.1469348 C129.059407,58.4133036 129.026327,58.6841045 128.900774,58.9428524 C128.775221,59.2016002 128.559831,59.4428845 128.267704,59.6520153 C127.975578,59.8611462 127.612828,60.03375 127.201541,60.1593208 C125.365906,60.7595108 123.409052,60.1593172 121.478172,60.2143347 C120.35601,60.271953 120.127091,60.8766583 119.983456,61.4571976 L119.937628,61.6490321 C119.900223,61.8068422 119.862471,61.9578902 119.807056,62.089932 C118.518648,64.7060327 116.165704,64.3905529 113.985456,64.0559193 L113.565961,63.9916944 C112.038157,63.7610616 110.637532,63.6154156 109.806301,64.5957259 C107.641779,68.2379443 105.339226,67.670634 103.07514,67.0870018 L102.727147,66.997649 C101.568339,66.7031471 100.422027,66.4609041 99.3120163,66.8364328 C98.9570114,67.0540016 98.6231115,67.3269003 98.2824468,67.6080828 L97.9881417,67.8500277 C97.0468126,68.6156614 95.99698,69.3432946 94.2813293,69.0921438 C91.2239729,67.8840304 88.3867225,66.4998417 85.813167,64.9608393 C82.5142196,63.0552364 79.3884428,60.999588 76.0894954,59.0939851 C74.9811876,58.4537825 73.8642234,57.828584 72.695305,57.2333957 C69.5522134,55.2977832 66.9632789,50.5412773 66.4004664,49.4759401 L88.1942961,36.8869539 C90.9217724,36.3117717 93.1816847,37.8972765 107.130778,36.9519769 C116.438832,36.4268103 121.443534,34.0260499 128.768756,31.0851188 C130.509146,30.1798323 131.080618,30.4199076 132.318805,31.1351339 Z M75.4574215,26.3086079 L85.2763323,31.9804026 C85.7210625,32.2372964 85.7210623,32.6538035 85.2763323,32.9106972 L58.5990205,48.3205719 C58.1542893,48.5774663 57.4332427,48.5774658 56.9885124,48.3205719 L47.1695979,42.6487791 C46.7248679,42.3918854 46.7248667,41.9753788 47.1695979,41.7184845 L73.8469096,26.3086079 C74.2916397,26.0517141 75.0126915,26.0517142 75.4574215,26.3086079 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.9%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LikeColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6096191,12.486084 C90.3480225,9.17132568 99.6519775,9.17129517 105.390381,12.4860535 L171.196167,50.4981079 C174.285645,52.2827148 175.711792,54.6642761 175.474609,57 L175.5,57 L175.5,92 L175.474609,92 C175.27124,94.0027161 173.845093,95.9717407 171.196167,97.5018921 L105.390381,135.513947 C99.6519775,138.828705 90.3480225,138.828705 84.6096191,135.513947 L18.803833,97.5018921 C16.1549072,95.9717407 14.7287598,94.0027161 14.5253906,92 L14.5,92 L14.5,57 L14.5253906,57 C14.288208,54.6642761 15.7143555,52.2827148 18.803833,50.4981079 L84.6096191,12.486084 Z",
    id: "Glow",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero",
    opacity: 0.699999988,
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.8195135,2.37914062 C90.1658962,-0.793046713 98.8341038,-0.793046951 104.180487,2.37914014 L165.490209,38.7562447 C170.836593,41.9284327 170.836592,47.0715637 165.490209,50.2437515 L104.18048,86.6208572 C98.8341018,89.7930422 90.1658978,89.7930529 84.8195135,86.6208649 L23.5097876,50.2437553 C18.1634044,47.071568 18.1634036,41.9284332 23.509788,38.7562447 L84.8195135,2.37914062 Z",
    id: "Subtract",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-14",
    fillOpacity: 0.230000004,
    fill: "#000000",
    fillRule: "nonzero",
    points: "47.9375 46.25 95 24.625 142.0625 46.25 142.0625 64.5625 95 86 47.9375 64.5625"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeColor);
export default __webpack_public_path__ + "static/media/LikeColor.beefe5baca36ae8ba52afa8e31125fba.svg";
export { ForwardRef as ReactComponent };